// extracted by mini-css-extract-plugin
export default {"refetchButton":"DisplayPageError_refetchButton__ML81v"};